import React from 'react';

import { CHIP_LIMIT } from './homeAccess';

/* One labelled row of access chips, shared by the full "Your access" panel and
   the zero-allocation welcome state so the two cannot drift apart visually.

   Items are {id, name} throughout rather than bare names: two venues may share
   a name, and keying React off the name alone would collapse them into one row
   that re-renders wrongly when either changes. */

function AccessChips({ items, emptyLabel }) {
    if (items.length === 0) {
        return <span className="tw-rounded-full tw-bg-charcoal-15 tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-charcoal">{emptyLabel}</span>;
    }

    const shown = items.slice(0, CHIP_LIMIT);
    const remaining = items.length - shown.length;

    return (
        <>
            {shown.map((item) => (
                <span key={item.id} className="tw-rounded-full tw-bg-blue-25 tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-dark-blue">
                    {item.name}
                </span>
            ))}
            {remaining > 0 && (
                <span className="tw-rounded-full tw-bg-charcoal-15 tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-text-charcoal">
                    {$t('+{{count}} more', { count: remaining })}
                </span>
            )}
        </>
    );
}

/* `note` sits inside the row, under the chips, so it lines up with them in
   either direction and the row keeps its last-row border rule. A note is long
   prose, so the column takes the remaining width and lets it wrap there. */
export default function AccessRow({ label, items, emptyLabel, note = null }) {
    return (
        <div className="tw-flex tw-flex-wrap tw-items-start tw-gap-x-4 tw-gap-y-2 tw-border-b tw-border-grey tw-py-3 last:tw-border-b-0">
            <span className="tw-w-32 tw-shrink-0 tw-pt-1 tw-text-xs tw-font-semibold tw-text-charcoal">{label}</span>
            <div className={`tw-flex tw-flex-col tw-gap-2 ${note ? 'tw-min-w-0 tw-flex-1' : ''}`}>
                <div className="tw-flex tw-flex-wrap tw-gap-2">
                    <AccessChips items={items} emptyLabel={emptyLabel} />
                </div>
                {note && <p className="tw-mb-0 tw-text-xs tw-text-charcoal-60">{note}</p>}
            </div>
        </div>
    );
}
